import { Link } from "react-router-dom";

const Footer = () => (
  <footer className="mt-10">
    <div className="container max-w-7xl mx-auto px-8 md:px-0 border-t-2">
      <div className="flex px-5 flex-col md:flex-row py-8 pb-10 items-start justify-between gap-10">
        <Link to="/" className="flex-shrink-0">
          <img src="/images/logo.svg" className="h-8" alt="logo" />
        </Link>
        <div className="flex flex-col sm:flex-row flex-1 justify-around gap-8">
          <div>
            <h6 className="font-medium mb-4">Company</h6>
            <Link to="/about" className="block text-sm my-3 text-gray-800">
              About Us
            </Link>
          </div>
          <div>
            <h6 className="font-medium mb-4">Legal & Policies</h6>
            <Link to="/terms-of-service" className="block text-sm my-3 text-gray-800">
              Terms of Service
            </Link>
            <Link to="/privacy-policy" className="block text-sm my-3 text-gray-800">
              Privacy Policy
            </Link>
          </div>
          <div>
            <h6 className="font-medium mb-4">Support & Contact</h6>
            <Link to="/contact" className="block text-sm my-3 text-gray-800">
              Contact Us
            </Link>
          </div>
          <div>
            <h6 className="font-medium mb-4">Developers</h6>
            <a
              className="block text-sm my-3 text-gray-800"
              href="https://documenter.getpostman.com/view/39110349/2sAXxY3o5v"
            >
              Documentation
            </a>
          </div>
        </div>
        <div className="md:text-right max-w-68">
          <a href="https://www.eiqdigital.com/" target="_blank" rel="noopener noreferrer">
            <img
              src="/images/eiqdigital_logo.png"
              className="inline-block w-52"
              alt="eIQdigital Logo"
            />
          </a>
          <p className="text-xs font-light text-gray-500 mb-2">
            ©2024 EIQdigital, Inc. All rights reserved.
          </p>
          <p className="text-xs font-light text-gray-500">
            UtilityConnect.ai
          </p>
          <p className="text-xs font-light text-gray-500">2700 Post Oak Blvd., 21st Floor Houston, TX 77056</p>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
